import Vuex from "vuex";
import VueRouter from "vue-router";
import { BootstrapVue } from "bootstrap-vue";
import VCalendar from "v-calendar";
import VuePapaParse from 'vue-papa-parse'
import 'animate.css';
import ShrPlugin, { AxiosService } from "@insidify/shr-ui-library";

import momentTimezone from 'moment-timezone';
import Intersect from "./directives/intersect";

import { MixpanelService } from '@insidify/shr-ui-library/';

import { mountCreator } from "@insidify/shr-ui-library";
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
import VueSocialauth from 'vue-social-auth'
// LaravelEncrypt is deprecated - using AsymmetricEncryptionService instead
import AsymmetricEncryptionMixin from './mixins/AsymmetricEncryptionMixin'
import getWorkStyleLabel from './helper/workStyle'
import AsymmetricEncryptionService from './services/AsymmetricEncryptionService'
import MixpanelTrackEvent from './mixins/MixpanelTrackEvent';
import { PermissionMixin } from './mixins/PermissionMixin'
import FeatureMixin from './mixins/FeatureMixin'
import Vue from "vue";

// window.Pusher = Pusher;
//
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'mykey',
//     cluster: 'us3',
//     wsHost: window.location.hostname,
//     wssPort: 6001,
//     encrypted: true,
//     disableStats: true,
//     authEndpoint: '/pusher/auth',
// })
//
// Pusher.log = function (message) {
//     window.console.log(message)
// }

const AxiosConfig = {
    headers: {
        common: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    },
};

const vueMountPoints = {
    admin: {
        mountName: 'adminMount',
        routes: require('./module/routes').default.admin,
        store: require('./module/store').default.admin,
    },
    jobApplication: {
        mountName: 'jobApplication',
        routes: require('./module/routes').default.jobApplication,
        store: require('./module/store').default.jobApplication,
    },
    applicants: {
        mountName: 'applicantsMount',
        routes: require('./module/routes').default.applicants,
        store: require('./module/store').default.applicants,
    },
    interviewer: {
        mountName: 'interviewerMount',
        routes: require('./module/routes').default.interviewer,
        store: require('./module/store').default.interviewer,
    },
    auth: {
        mountName: 'authMount',
    }
}

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    AxiosConfig.headers.common['X-CSRF-TOKEN'] = token.content;
}

// register axios globally
window.axios = AxiosService(AxiosConfig);
window.Vue = Vue;
window.VueRouter = VueRouter;
window.Vuex = Vuex;

// Install Vue Plugins
Vue.use(BootstrapVue);
Vue.use(VCalendar, {});
Vue.use(VuePapaParse);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ShrPlugin, {
    config: {
        vue: {
            productionTip: false,
        },
        axios: AxiosConfig
    }
});

// Register Vue Mixins
Vue.mixin(MixpanelTrackEvent);
Vue.mixin(PermissionMixin);
Vue.mixin(FeatureMixin);
Vue.mixin(AsymmetricEncryptionMixin);

// Register Vue Directives
Vue.directive('intersect', Intersect);

// Initialize encryption service with keys from window
// Keys are injected by backend in master.blade.php
try {
    AsymmetricEncryptionService.initializeKeys();
} catch (error) {
    console.error('Failed to initialize encryption service:', error);
}

// Decrypt OAuth credentials using new asymmetric encryption
// NO FALLBACK TO LaravelEncrypt - this is the only way to avoid exposing APP_KEY
function decryptOAuthCredential(encryptedValue) {
    // Handle empty or missing values
    if (!encryptedValue || encryptedValue.trim() === '' || encryptedValue === 'null') {
        return '';
    }
    
    try {
        // Ensure keys are initialized
        AsymmetricEncryptionService.initializeKeys();
        
        // Check if keys are available
        const keyStatus = AsymmetricEncryptionService.getKeyStatus();
        if (!keyStatus.pair2PrivateKey) {
            console.warn('Pair 2 private key not available for OAuth decryption. OAuth features may not work.');
            return '';
        }
        
        // Use new asymmetric decryption (Pair 2: backend encrypts, frontend decrypts)
        const decrypted = AsymmetricEncryptionService.decryptFromBackend(encryptedValue);
        return decrypted || '';
    } catch (error) {
        console.error('Failed to decrypt OAuth credential:', error);
        return '';
    }
}

Vue.use(VueSocialauth, {
  providers: {
    google: {
      clientId: decryptOAuthCredential(window.mySettings.google.client_id),
      clientSecret: decryptOAuthCredential(window.mySettings.google.client_secret),
      redirectUri: decryptOAuthCredential(window.mySettings.google.redirect),
      // Without prompt=select_account Google silently reuses the one signed-in session
      // and skips consent for an already-authorised app, so the member never gets to
      // pick an account. optionalUrlParams replaces the package default wholesale
      // (objectExtend does not merge arrays), so 'display' has to be repeated here.
      prompt: 'select_account',
      optionalUrlParams: ['display', 'prompt']
    },
    linkedin: {
      scope: ['profile', 'email', 'openid'],
      clientId: decryptOAuthCredential(window.mySettings.linkedin.client_id),
      clientSecret: decryptOAuthCredential(window.mySettings.linkedin.client_secret),
      redirectUri: decryptOAuthCredential(window.mySettings.linkedin.redirect)
    }
  }
})
// Relative times floor instead of rounding, so a deadline never reads as more time
// than there is: 3 months 25 days shows "3 months", not "4 months". This also makes
// moment agree with Carbon's diffForHumans(), which truncates - the two were a whole
// month apart on the job list vs the blade job page. moment-timezone shares this module
// instance, so it covers formatTimezone()'s fromNow() too.
momentTimezone.relativeTimeRounding(Math.floor);

Vue.prototype.$momentTimezone = momentTimezone;
Vue.prototype.$getWorkStyleLabel = getWorkStyleLabel;

require('./module/components')

mountCreator(vueMountPoints.admin);
mountCreator(vueMountPoints.jobApplication);
mountCreator(vueMountPoints.applicants);
mountCreator(vueMountPoints.interviewer);
mountCreator(vueMountPoints.auth);
mountCreator(
    {
        mountName: 'landingPage',
        store: require('./module/store').default.jobApplication
    }
);
mountCreator(
    {
        mountName: 'playground',
        store: require('./module/store').default.playground
    }
);
MixpanelService.initIdentify(process.env.MIX_MIXPANEL_API_KEY);
